var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":_vm.$store.state.darkMode}},[_c('page-header'),_c('main',[_c('router-view')],1),_c('dark-mode')],1)}
var staticRenderFns = []

export { render, staticRenderFns }